<!--
 * @Description: 学生学籍异动记录 添加
 * @Author: ZSC
 * @Date: 2023-04-20 11:28:35.790
 * @LastEditors: PF
 * @LastEditTime: 2026-09-18 14:04:36
-->
<template>
  <div>
    <el-dialog class="w800 hp73" :model-value="openAdd" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">添加</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openAdd', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-form ref="ruleFormRef" :model="ruleForm" label-width="100px">
        <el-row gutter="10">
          <el-col :span="12">
            <el-form-item label="学生" prop="xsid" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-button class="mr10" type="primary" @click="openDanTiao=true">选择</el-button>
              <el-tag class="mr10 mt10" v-if="ruleForm.xsid" closable @close="CourseClose">{{ruleForm.xm}}</el-tag>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="异动类别" prop="ydlb" :rules="[{ required: true, message: '请选择异动类别', trigger: ['change', 'blur'] }]">
              <el-select v-model="ruleForm.ydlb" clearable filterable>
                <el-option v-for="(item, index) in ydlxData.list" :key="index" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="异动日期" prop="ydrq" :rules="[{ required: true, message: '请选择异动日期', trigger: ['change', 'blur'] }]">
              <el-date-picker v-model="ruleForm.ydrq" type="date" value-format="YYYY-MM-DD" clearable filterable />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="异动原因" prop="ydyyid" :rules="[{ required: true, message: '请选择异动原因', trigger: ['change', 'blur'] }]">
              <el-select v-model="ruleForm.ydyyid" clearable filterable>
                <el-option v-for="item in ydyyData" :key="item.id" :label="item.bt" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="ruleForm.ydlb === 99">
            <el-form-item label="审批后状态" prop="sphzt">
              <el-select v-model="ruleForm.sphzt" clearable filterable>
                <el-option v-for="item in sphztList" :key="item.id" :label="item.label" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="isLeaveOut">
            <el-form-item label="异动来源学校" prop="ydlyxx">
              <el-input v-model="ruleForm.ydlyxx" clearable filterable />
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="isLeaveOut">
            <el-form-item label="异动去向学校" prop="ydqxxx">
              <el-input v-model="ruleForm.ydqxxx" clearable filterable />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="异动说明" prop="ydsm">
              <el-input v-model="ruleForm.ydsm" type="textarea" resize="none" :autosize='{minRows: 4, maxRows: 4}' />
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="isLevelChange">
            <el-form-item label="">
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="isLevelChange">
            <el-form-item label="现层次">
              <el-select v-model="ruleForm.xccid" filterable @change="initZhuanYe()">
                <el-option v-for="item in ccData" :key="item.id" :label="item.bt" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="isLevelChange">
            <el-form-item label="原年级">
              {{ ruleForm.ynjmc }}
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="isLevelChange">
            <el-form-item label="现年级" prop="xnjid">
              <el-select v-model="ruleForm.xnjid" filterable @change="initXianBanJiList()">
                <el-option v-for="item in njData" :key="item.id" :label="item.njmc" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="isLevelChange">
            <el-form-item label="原专业">
              {{ ruleForm.yzymc }}
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="isLevelChange">
            <el-form-item label="现专业" prop="xzyid">
              <el-select v-model="ruleForm.xzyid" filterable @change="initXianBanJiList()">
                <el-option v-for="item in zyData" :key="item.id" :label="item.zymc" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="isLevelChange">
            <el-form-item label="原班级">
              {{ ruleForm.ybjmc }}
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="isLevelChange">
            <el-form-item label="现班级" prop="xbjid">
              <el-select v-model="ruleForm.xbjid" filterable>
                <el-option v-for="item in bjData" :key="item.id" :label="item.xzbmc" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="primary" @click="submit()">保存</el-button>
            <el-button type="info" @click="closeWindow('openAdd', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
  <xueshengdantiao v-if="openDanTiao" v-model:openDanTiao="openDanTiao" @ReturnData="ReturnData" />
</template>

<script setup>
import { defineProps, defineEmits, ref, watch, unref, computed } from 'vue'
import {
  submitForm,
  closeWindow,
  loadSelect,
  actionPost
} from '@/api/common.js'
import { loadZiDianSelect } from '@/api/queryZiDian.js'
import { getXjydlx } from '@/utils/meiju'
import xueshengdantiao from '@/components/chazhaodaihui/xueshengdantiao.vue'

const props = defineProps({ openAdd: { type: Boolean, required: true } })
const emits = defineEmits(['update:openAdd', 'ReturnData'])

const ruleFormRef = ref(null)
const ruleForm = ref({})

// 学生列表
const openDanTiao = ref(false)
const ReturnData = (data) => {
  ruleForm.value.xsid = data.id
  ruleForm.value.xm = data.xm
  huoQuXueShengChange(data.id)
}
const CourseClose = () => {
  ruleForm.value.xsid = ''
  ruleForm.value.xm = ''
}
const huoQuXueShengChange = (val) => {
  const o = { url: '/api/v2/pdp/xuesheng/' + val, data: {} }
  actionPost(o).then((res) => {
    ruleForm.value.ynjmc = res.data.xsxj.njmc
    ruleForm.value.yzymc = res.data.xsxj.zymc
    ruleForm.value.ybjmc = res.data.xsxj.bjmc
    ruleForm.value.xccid = res.data.ccid
    initZhuanYe()
    ruleForm.value.xnjid = res.data.xsxj.njid
    ruleForm.value.xzyid = res.data.xsxj.zyid
    initXianBanJiList()
    ruleForm.value.xbjid = res.data.xsxj.bjid
  })
}

const ydlxData = ref(getXjydlx()) // 学籍异动类型
// 学业层级变动类异动
const LEVEL_CHANGE_TYPES = [
  ydlxData.value.liuJi,
  ydlxData.value.jiangJi,
  ydlxData.value.tiaoJi,
  ydlxData.value.shiDu,
  ydlxData.value.huiGuoFuXue,
  ydlxData.value.fuXue,
  ydlxData.value.huiFuXueJi,
  ydlxData.value.zhuanXueZhuanChu,
  ydlxData.value.zhuanXueZhuanRu,
  ydlxData.value.zhuanZhuanYe,
  ydlxData.value.zhuanBanJi,
  ydlxData.value.guoNeiFangXueHouFanXiao,
  ydlxData.value.qiTa
]
const isLevelChange = computed(() =>
  LEVEL_CHANGE_TYPES.includes(ruleForm.value.ydlb)
)
// 离校外出类异动
const LEVEL_OUT_TYPES = [
  ydlxData.value.gongPaiLiuXue,
  ydlxData.value.huiGuoFuXue,
  ydlxData.value.zhuanXueZhuanChu,
  ydlxData.value.zhuanXueZhuanRu,
  ydlxData.value.guoNeiFangXue,
  ydlxData.value.guoNeiFangXueHouFanXiao,
  ydlxData.value.qiTa
]
const isLeaveOut = computed(() =>
  LEVEL_OUT_TYPES.includes(ruleForm.value.ydlb)
)

// 学籍异动原因列表
const ydyyData = ref([])
// 审批后状态
// 状态 [13]公派 [5]复学 [2]休学 [4]停学 [12]保留入学资格 [10]转学 [1]在读 [3]退学 [14]开除 [11]死亡 [7]毕业 [8]结业 [9]肄业 [15]下落不明 [6]流失
const sphztList = ref([
  { id: 15, label: '下落不明' },
  { id: 6, label: '流失' },
  { id: 1, label: '在读' }
])
// 现专业
const zyData = ref([])
const initZhuanYe = () => {
  loadSelect({
    url: '/api/v2/pdp/zhuanye/list',
    data: zyData,
    parms: { ccid: ruleForm.value.xccid, order: 'zybh', sort: 'asc' }
  })
}
// 现班级
const bjData = ref([])
const initXianBanJiList = () => {
  if (ruleForm.value.xzyid && ruleForm.value.xnjid) {
    const obj = {
      zyid: ruleForm.value.xzyid,
      njid: ruleForm.value.xnjid
    }
    loadSelect({
      url: '/api/v2/pdp/banji/list',
      data: bjData,
      parms: obj,
      order: 'xzbmc',
      sort: 'asc'
    })
  }
}
// 现年级
const njData = ref([])
// 加载 层次 下拉框
const ccData = ref()
watch(
  () => props.openAdd,
  () => {
    if (props.openAdd) {
      ruleForm.value = {}
      loadZiDianSelect('层次', ccData, 'sx', 'asc')
      loadZiDianSelect('学籍异动原因', ydyyData)
      loadSelect({
        url: '/api/v2/pdp/nianji/list',
        data: njData,
        order: 'njdm',
        sort: 'asc'
      })
    }
  },
  { deep: true, immediate: true }
)

// 提交
const submit = async () => {
  submitForm({
    url: '/api/v2/jiaowu/xueshengxuejiyidongjilu',
    ruleFormRef: unref(ruleFormRef),
    ruleForm: ruleForm.value,
    callback: function () {
      closeWindow('openAdd', emits, true)
    }
  })
}
</script>
